import { routes } from '@/lib/routes';
import type {
  Publication,
  QuickAction,
  ResearchRequest,
  StatMetric,
  TeamMember,
  TimelineEntry,
} from '@/types';

export const statMetrics: StatMetric[] = [
  {
    id: 'requests',
    labelKey: 'dashboard.stat.requests',
    value: 128,
    progress: 72,
    accent: '#41d2ff',
  },
  {
    id: 'publications',
    labelKey: 'dashboard.stat.publications',
    value: 342,
    progress: 58,
    accent: '#49ddb7',
  },
  {
    id: 'learners',
    labelKey: 'dashboard.stat.learners',
    value: 57,
    progress: 44,
    accent: '#d9a73a',
  },
  {
    id: 'attention',
    labelKey: 'dashboard.stat.attention',
    value: 9,
    progress: 24,
    accent: '#ff6e56',
  },
];

export const dashboardActions: QuickAction[] = [
  {
    id: 'new-request',
    titleKey: 'dashboard.action.newRequest',
    descriptionKey: 'dashboard.action.newRequestText',
    icon: 'briefcase',
    to: routes.newRequest,
  },
  {
    id: 'review',
    titleKey: 'dashboard.action.review',
    descriptionKey: 'dashboard.action.reviewText',
    icon: 'document',
    to: routes.journals,
  },
  {
    id: 'report',
    titleKey: 'dashboard.action.report',
    descriptionKey: 'dashboard.action.reportText',
    icon: 'chart',
    to: routes.audit,
  },
  {
    id: 'mentor',
    titleKey: 'dashboard.action.mentor',
    descriptionKey: 'dashboard.action.mentorText',
    icon: 'user',
    to: routes.people,
  },
];

export const timelineEntries: TimelineEntry[] = [
  { id: 'tl-1', messageKey: 'dashboard.timeline.1', timeKey: 'dashboard.time.min10' },
  { id: 'tl-2', messageKey: 'dashboard.timeline.2', timeKey: 'dashboard.time.hour1' },
  { id: 'tl-3', messageKey: 'dashboard.timeline.3', timeKey: 'dashboard.time.yesterday' },
  { id: 'tl-4', messageKey: 'dashboard.timeline.4', timeKey: 'dashboard.time.days2' },
];

export const teamMembers: TeamMember[] = [
  { id: 'tm-1', name: 'Асель Б.', initials: 'АБ', roleKey: 'dashboard.role.curator' },
  { id: 'tm-2', name: 'Дамир К.', initials: 'ДК', roleKey: 'dashboard.role.mentor' },
  { id: 'tm-3', name: 'Марат Т.', initials: 'МТ', roleKey: 'dashboard.role.editor' },
  { id: 'tm-4', name: 'Сая Ж.', initials: 'СЖ', roleKey: 'dashboard.role.admin' },
];

export const researchRequests: ResearchRequest[] = [
  {
    id: 'rq-1',
    code: '№0231',
    topic: 'Цифровая лингвистика казахского языка',
    direction: 'requests.direction.humanities',
    owner: 'Асель Б.',
    status: 'review',
    updatedAt: '2026-08-24T09:20:00.000Z',
  },
  {
    id: 'rq-2',
    code: '№0230',
    topic: 'Модели прогнозирования водных ресурсов',
    direction: 'requests.direction.natural',
    owner: 'Дамир К.',
    status: 'approved',
    updatedAt: '2026-08-21T13:05:00.000Z',
  },
  {
    id: 'rq-3',
    code: '№0229',
    topic: 'Промышленная автоматизация на базе IoT',
    direction: 'requests.direction.technical',
    owner: 'Марат Т.',
    status: 'draft',
    updatedAt: '2026-08-19T07:40:00.000Z',
  },
  {
    id: 'rq-4',
    code: '№0228',
    topic: 'Социология академической мобильности',
    direction: 'requests.direction.humanities',
    owner: 'Сая Ж.',
    status: 'rejected',
    updatedAt: '2026-08-12T16:15:00.000Z',
  },
];

export const publications: Publication[] = [
  {
    id: 'pb-1',
    title: 'Neural morphology of agglutinative languages',
    journal: 'Journal of Computational Linguistics',
    indexed: 'Scopus Q1',
    status: 'approved',
    year: 2026,
  },
  {
    id: 'pb-2',
    title: 'Water balance forecasting in arid regions',
    journal: 'Hydrology Research',
    indexed: 'Web of Science',
    status: 'review',
    year: 2026,
  },
  {
    id: 'pb-3',
    title: 'Edge computing for industrial telemetry',
    journal: 'IEEE Access',
    indexed: 'Scopus Q2',
    status: 'draft',
    year: 2025,
  },
];
